module.exports = __webpack_public_path__ + "img/viktor_krum_with_a_sharks_head.4458b1a9.jpg";